// Parsing logic matches the server; browser imports must use the ESM entry.
// Country is a phone-number country explicitly selected by the buyer, never geography.
import { parsePhoneNumberFromString, isSupportedCountry } from 'libphonenumber-js/max';

const normalizePhoneCountry = (country) => {
  if (typeof country !== 'string' || !/^[a-z]{2}$/i.test(country)) return '';
  const code = country.toUpperCase();
  return isSupportedCountry(code) ? code : '';
};

const isInternationalPhone = (phone) => (
  typeof phone === 'string' && /^(?:\+|00)/.test(phone.trim())
);

const normalizeMetaPhone = (phone, phoneCountry) => {
  // Reject coercion, truncation, prose, extensions and post-dial instructions.
  // Dropping those characters could turn a different contact into a match key.
  if (typeof phone !== 'string' || phone.length > 80) return '';
  const value = phone.trim();
  if (!value || !/^\+?[0-9 () .-]+$/.test(value)) return '';
  const international = isInternationalPhone(value);
  const country = normalizePhoneCountry(phoneCountry);
  if (!international && !country) return '';
  const input = value.startsWith('00') ? '+' + value.slice(2) : value;
  try {
    const parsed = parsePhoneNumberFromString(input, {
      defaultCountry: international ? undefined : country,
      extract: false
    });
    if (!parsed || parsed.ext || !parsed.isValid()) return '';
    // Country-code-plus-national digits; retain significant national zeros (e.g. Italy).
    return /^\+[1-9][0-9]{1,14}$/.test(parsed.number) ? parsed.number.slice(1) : '';
  } catch {
    return '';
  }
};

export { normalizeMetaPhone, normalizePhoneCountry, isInternationalPhone };
